
export const Error = {
    53000: "Unable to connect to server. Please make sure to have a stable internet connection",
    53105: 'Not applicabel for us as it is one to one. We are facing some issue. Please reach out to our customer support team for further asstance',
    53106: 'We are facing some issue. Please reach out to our customer support team for further assistance',
    53405: 'Please make sure to have a stable internet connection. In case you are behind a firewall please allow media traffic to and from C2C to go through',
    53001: 'Your internet connection is not stable. Please make sure to have a stable internet connection.',
    53002: 'Unable to connect right now. Please try reconnecting again',
    53205: 'Need to handled programatically. Unable to connect right now. Please try connecting (by clicking "Join Call" ) again after some time',
}